module.exports = __webpack_public_path__ + "img/iphone-1.a37962ee.svg";